import {
  Handle, Position,
} from 'reactflow';
import 'reactflow/dist/style.css';

/**
 * グループノードパラメータ
 */
interface GroupNodeProps {
  data: {
    /** 接続点（左側）表示有無 */
    left: boolean,
    /** 接続点（右側）表示有無 */
    right: boolean,
  };
}
/**
 * グループノード
 * @param data グループノードデータ
 */
const GroupNode: React.FC<GroupNodeProps> = ({ data }) => {
  return (

    <div
      style={{
        zIndex: 1,
        width: '100%',
        height: '100%',
      }}
    >
      {/* 接続点（右側） */}
      {data.right && <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{ background: '#000' }}
      />}

      {/* 接続点（左側） */}
      {data.left &&
        <Handle
          type="target"
          position={Position.Left}
          id="left"
          style={{ background: '#000' }}
        />}
    </div>
  );
};

export default GroupNode;